import React from 'react';
export function TopBanner() {
  return <div className="w-full bg-wh-pink text-white py-2 text-center" data-id="element-361">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-362">
        <p className="text-xs sm:text-sm font-medium" data-id="element-363">
          Screen Printing • Embroidery • DTF • Laser Engraving • Rhinestones •
          Promotional Products | Est. 1992 • LaGrange, Indiana
        </p>
      </div>
    </div>;
}